import { useQuery } from '@tanstack/react-query'
import { scopeAdminApi } from '../lib/api'
import type { DistrictCatalogResponse } from '../types/scoping'

/**
 * WL-4b (Task 8): the DISTINCT verbatim district-code catalog for one state, split by chamber --
 * backs the grant editor's per-state district-code dropdown (`ScopeConfigPage`'s
 * `DistrictStateBox`). SuperAdmin-only endpoint (Task 7); disabled until a state is chosen.
 * Reference data (the held voter file, not a live/per-request value) so it's cached indefinitely
 * like the sibling `useAvailableStates`/`useAvailableDistricts` hooks.
 */
export function useDistrictCatalog(state?: string) {
  return useQuery<DistrictCatalogResponse>({
    queryKey: ['scope', 'district-catalog', state],
    enabled: !!state,
    queryFn: () => scopeAdminApi.getDistrictCatalog(state!).then((r) => r.data),
    staleTime: Infinity,
  })
}
